import React from "react";
import ReactECharts from "echarts-for-react";

const DemoLineChart = () => {
  // Dataset
  const dataWeek = [
    { Day: 1, Count: 0 },
    { Day: 2, Count: 0 },
    { Day: 3, Count: 0 },
    { Day: 4, Count: 0 },
    { Day: 5, Count: 1 },
    { Day: 6, Count: 0 },
    { Day: 7, Count: 0 },
    { Day: 8, Count: 0 },
    { Day: 9, Count: 0 },
    { Day: 10, Count: 0 },
    { Day: 11, Count: 49 },
    { Day: 12, Count: 49 },
    { Day: 13, Count: 50 },
    { Day: 14, Count: 0 },
    { Day: 15, Count: 1 },
    { Day: 16, Count: 0 },
    { Day: 17, Count: 0 },
    { Day: 18, Count: 2 },
    { Day: 19, Count: 1 },
    { Day: 20, Count: 3 },
    { Day: 21, Count: 1 },
    { Day: 22, Count: 30 },
    { Day: 23, Count: 0 },
    { Day: 24, Count: 10 },
    { Day: 25, Count: 30 },
    { Day: 26, Count: 40 },
    { Day: 27, Count: 30 },
    { Day: 28, Count: 50 },
    { Day: 29, Count: "None" },
    { Day: 30, Count: "None" },
    { Day: 31, Count: "None" },
  ];


//   const dataWeek = [
//     { Day: 'Saturday', Count: 2 },
//     { Day: 'Sunday', Count: 5 },
//     { Day: 'Monday', Count: 8 },
//     { Day: 'Tuesday', Count: 9 },
//     { Day: 'Thursday', Count: null },
//     { Day: 'Friday', Count: null },
//     { Day: 'Saturday', Count: null },
//   ];

  // Prepare data for the chart
  const xAxisData = dataWeek.map((item) => `${item.Day}`);
  const yAxisData = dataWeek.map((item) =>
    typeof item.Count === "number" ? item.Count : null
  );

  // ECharts option
  const options = {
    title: {
      text: "Total Demos Ran by Team",
      left: "center",
    },
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const item = params[0];
        if (item.data!==null) {
          return `${item.axisValue}<br/>Count: ${item.data}`;
        }
        return null; 
      },
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      boundaryGap: false,
      axisTick: {
        alignWithLabel: true,
        inside: true, // Position ticks inside, making them appear higher
      },
      axisLabel: {
        showMinLabel: true, // Always show the first label
        showMaxLabel: true, // Always show the last label
        interval: 'auto', // Show all labels; adjust as needed based on space
      },
    },
    yAxis: {
      type: "value",
      min: 0,
      boundaryGap: [0, 0.1],
    },
    series: [
      {
        name: "Demos Ran",
        type: "line",
        data: yAxisData,
        connectNulls: false, // Do not connect NA values in the line
        lineStyle: {
          width: 2,
        },
        symbol: "circle",
        symbolSize: 6,
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: "400px", width: "100%" }} />
  );
};

export default DemoLineChart;
